import React from 'react';
import { Trash2, Shield, AlertCircle, CheckCircle, Clock, FileText, MessageSquare, Mail } from 'lucide-react';

export const Eliminacion = () => {

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-12 px-4">
            <div className="max-w-4xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-2xl shadow-xl p-8 mb-8 border border-indigo-100">
                    <div className="flex items-center gap-4 mb-4">
                        <div className="bg-gradient-to-br from-red-500 to-orange-500 p-3 rounded-xl">
                            <Trash2 className="w-8 h-8 text-white" />
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">Eliminación de Datos de Usuario</h1>
                            <p className="text-indigo-600 font-semibold text-lg">Titania by Neotec - WhatsApp Integration</p>
                        </div>
                    </div>
                    <p className="text-gray-600 leading-relaxed">
                        En TITANIA respetamos su derecho a la privacidad y al control de sus datos personales.
                        Esta página le permite solicitar la eliminación de sus datos asociados con nuestra integración de WhatsApp.
                    </p>
                </div>

                {/* Información sobre los datos */}
                <div className="bg-white rounded-xl shadow-md p-6 mb-6 border border-gray-200">
                    <div className="flex items-start gap-3 mb-4">
                        <div className="bg-indigo-100 p-2 rounded-lg">
                            <Shield className="w-5 h-5 text-indigo-600" />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-gray-900 mb-2">
                                ¿Qué datos recopilamos a través de WhatsApp?
                            </h2>
                            <p className="text-gray-600 mb-4">
                                Cuando utiliza nuestra integración con WhatsApp, podemos recopilar y procesar:
                            </p>
                        </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4 ml-11">
                        <div className="bg-gray-50 rounded-lg p-4">
                            <h3 className="font-semibold text-gray-900 mb-2 flex items-center gap-2">
                                <MessageSquare className="w-4 h-4 text-indigo-600" />
                                Datos de WhatsApp
                            </h3>
                            <ul className="text-sm text-gray-600 space-y-1">
                                <li>• Número de teléfono</li>
                                <li>• Nombre de perfil</li>
                                <li>• Mensajes enviados a TITANIA</li>
                                <li>• Historial de conversaciones</li>
                            </ul>
                        </div>

                        <div className="bg-gray-50 rounded-lg p-4">
                            <h3 className="font-semibold text-gray-900 mb-2 flex items-center gap-2">
                                <FileText className="w-4 h-4 text-indigo-600" />
                                Datos de Transacciones
                            </h3>
                            <ul className="text-sm text-gray-600 space-y-1">
                                <li>• Comprobantes enviados</li>
                                <li>• Órdenes de compra registradas</li>
                                <li>• Gastos reportados</li>
                                <li>• Aprobaciones realizadas</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Proceso de eliminación */}
                <div className="bg-white rounded-xl shadow-md p-6 mb-6 border border-gray-200">
                    <div className="flex items-start gap-3 mb-4">
                        <div className="bg-orange-100 p-2 rounded-lg">
                            <Clock className="w-5 h-5 text-orange-600" />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-gray-900 mb-2">
                                Proceso de Eliminación
                            </h2>
                            <p className="text-gray-600 mb-4">
                                Una vez recibida su solicitud, seguimos este proceso:
                            </p>
                        </div>
                    </div>

                    <div className="ml-11 space-y-4">
                        <div className="flex gap-4">
                            <div className="flex-shrink-0 w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                                1
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-900">Verificación de identidad</h3>
                                <p className="text-sm text-gray-600">Confirmamos que usted es el titular de los datos mediante el correo electrónico o número de teléfono registrado.</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="flex-shrink-0 w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                                2
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-900">Procesamiento (hasta 30 días)</h3>
                                <p className="text-sm text-gray-600">Eliminamos todos sus datos personales de nuestros sistemas, incluyendo bases de datos y copias de respaldo.</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="flex-shrink-0 w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                                3
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-900">Confirmación</h3>
                                <p className="text-sm text-gray-600">Le enviamos un correo electrónico confirmando la eliminación completa de sus datos.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Información importante */}
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 mb-6">
                    <div className="flex items-start gap-3">
                        <AlertCircle className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" />
                        <div>
                            <h3 className="font-bold text-amber-900 mb-2">Información Importante</h3>
                            <ul className="text-sm text-amber-800 space-y-2">
                                <li>• La eliminación de datos es <strong>permanente e irreversible</strong>.</li>
                                <li>• Perderá acceso a todas las funciones de WhatsApp conectadas a TITANIA.</li>
                                <li>• Los datos que su empresa necesite mantener por obligaciones legales o fiscales se conservarán según lo requiera la ley.</li>
                                <li>• Si es parte de una organización, algunos datos pueden ser retenidos por requerimientos empresariales.</li>
                                <li>• Puede tomar hasta 30 días hábiles procesar su solicitud completamente.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Instrucciones para solicitud por correo */}
                <div className="bg-white rounded-xl shadow-md p-6 mb-6 border border-gray-200">
                    <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                        <Mail className="w-6 h-6 text-indigo-600" />
                        Cómo Solicitar la Eliminación de sus Datos
                    </h2>

                    <p className="text-gray-600 mb-6">
                        Para solicitar la eliminación de sus datos, debe enviarnos un correo electrónico con la información requerida.
                        Siga las instrucciones a continuación:
                    </p>

                    <div className="space-y-6">
                        {/* Paso 1: Asunto */}
                        <div className="bg-indigo-50 border-l-4 border-indigo-600 p-4 rounded-r-lg">
                            <h3 className="font-bold text-indigo-900 mb-2 flex items-center gap-2">
                                <span className="bg-indigo-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">1</span>
                                Asunto del Correo
                            </h3>
                            <p className="text-sm text-indigo-800 mb-3">
                                El asunto debe ser exactamente el siguiente (puede copiar y pegar):
                            </p>
                            <div className="bg-white rounded-lg p-3 border border-indigo-200">
                                <code className="text-indigo-900 font-mono text-sm">
                                    SOLICITUD DE ELIMINACIÓN DE DATOS - TITANIA WHATSAPP
                                </code>
                            </div>
                        </div>

                        {/* Paso 2: Destinatario */}
                        <div className="bg-blue-50 border-l-4 border-blue-600 p-4 rounded-r-lg">
                            <h3 className="font-bold text-blue-900 mb-2 flex items-center gap-2">
                                <span className="bg-blue-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">2</span>
                                Enviar a
                            </h3>
                            <div className="bg-white rounded-lg p-3 border border-blue-200">
                                <a
                                    href="mailto:privacidad@titania.com?subject=SOLICITUD DE ELIMINACIÓN DE DATOS - TITANIA WHATSAPP"
                                    className="text-blue-600 font-semibold hover:text-blue-700 transition-colors"
                                >
                                    contacto@neotec.pe
                                </a>
                            </div>
                        </div>

                        {/* Paso 3: Contenido requerido */}
                        <div className="bg-purple-50 border-l-4 border-purple-600 p-4 rounded-r-lg">
                            <h3 className="font-bold text-purple-900 mb-2 flex items-center gap-2">
                                <span className="bg-purple-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">3</span>
                                Información Requerida en el Correo
                            </h3>
                            <p className="text-sm text-purple-800 mb-3">
                                Su correo debe incluir la siguiente información:
                            </p>
                            <div className="bg-white rounded-lg p-4 border border-purple-200 space-y-3">
                                <div className="flex items-start gap-2">
                                    <CheckCircle className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" />
                                    <div>
                                        <strong className="text-gray-900">Nombre completo:</strong>
                                        <span className="text-gray-600 ml-2">Su nombre tal como aparece en TITANIA</span>
                                    </div>
                                </div>
                                <div className="flex items-start gap-2">
                                    <CheckCircle className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" />
                                    <div>
                                        <strong className="text-gray-900">Correo electrónico registrado:</strong>
                                        <span className="text-gray-600 ml-2">El correo asociado a su cuenta</span>
                                    </div>
                                </div>
                                <div className="flex items-start gap-2">
                                    <CheckCircle className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" />
                                    <div>
                                        <strong className="text-gray-900">Número de teléfono WhatsApp:</strong>
                                        <span className="text-gray-600 ml-2">Incluir código de país (ej: +51 999 999 999)</span>
                                    </div>
                                </div>
                                <div className="flex items-start gap-2">
                                    <CheckCircle className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" />
                                    <div>
                                        <strong className="text-gray-900">Nombre de la empresa:</strong>
                                        <span className="text-gray-600 ml-2">Si aplica</span>
                                    </div>
                                </div>
                                <div className="flex items-start gap-2">
                                    <CheckCircle className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" />
                                    <div>
                                        <strong className="text-gray-900">Confirmación:</strong>
                                        <span className="text-gray-600 ml-2">Escriba "Confirmo que deseo eliminar permanentemente mis datos"</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Ejemplo de correo */}
                        <div className="bg-gray-50 border border-gray-300 rounded-lg p-4">
                            <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                                <FileText className="w-5 h-5 text-gray-600" />
                                Ejemplo de Correo
                            </h3>
                            <div className="bg-white border border-gray-200 rounded-lg p-4 font-mono text-sm text-gray-700 space-y-2">
                                <p><strong>Para:</strong> privacidad@titania.com</p>
                                <p><strong>Asunto:</strong> SOLICITUD DE ELIMINACIÓN DE DATOS - TITANIA WHATSAPP</p>
                                <hr className="border-gray-300 my-3" />
                                <p>Estimado equipo de TITANIA,</p>
                                <p className="mt-3">Por medio de la presente, solicito la eliminación de mis datos personales:</p>
                                <ul className="mt-3 space-y-1 ml-4">
                                    <li>• Nombre completo: Juan Pérez García</li>
                                    <li>• Correo electrónico: juan.perez@ejemplo.com</li>
                                    <li>• Número WhatsApp: +51 999 999 999</li>
                                    <li>• Empresa: Mi Empresa SAC</li>
                                </ul>
                                <p className="mt-3">Confirmo que deseo eliminar permanentemente mis datos.</p>
                                <p className="mt-3">Atentamente,<br />Juan Pérez</p>
                            </div>
                        </div>

                        {/* Tiempo de respuesta */}
                        <div className="bg-green-50 border-l-4 border-green-600 p-4 rounded-r-lg">
                            <h3 className="font-bold text-green-900 mb-2 flex items-center gap-2">
                                <Clock className="w-5 h-5 text-green-600" />
                                Tiempo de Respuesta
                            </h3>
                            <p className="text-sm text-green-800">
                                Procesaremos su solicitud dentro de <strong>30 días hábiles</strong> a partir de la recepción del correo.
                                Recibirá una confirmación por correo electrónico cuando su solicitud haya sido completada.
                            </p>
                        </div>

                        {/* Botón para enviar correo */}
                        <div className="text-center pt-4">
                            <a
                                href="mailto:contacto@neotec.pe?subject=SOLICITUD DE ELIMINACIÓN DE DATOS - TITANIA WHATSAPP&body=Estimado equipo de TITANIA,%0D%0A%0D%0APor medio de la presente, solicito la eliminación de mis datos personales:%0D%0A%0D%0A• Nombre completo: [Su nombre]%0D%0A• Correo electrónico: [Su correo]%0D%0A• Número WhatsApp: [Su número]%0D%0A• Empresa: [Nombre de su empresa]%0D%0A%0D%0AConfirmo que deseo eliminar permanentemente mis datos.%0D%0A%0D%0AAtentamente,%0D%0A[Su nombre]"
                                className="inline-flex items-center gap-2 bg-gradient-to-r from-red-500 to-orange-500 text-white px-8 py-3 rounded-lg font-semibold hover:from-red-600 hover:to-orange-600 transition-all shadow-md"
                            >
                                <Mail className="w-5 h-5" />
                                Abrir Cliente de Correo
                            </a>
                            <p className="text-xs text-gray-500 mt-2">
                                Se abrirá su cliente de correo con una plantilla prellenada
                            </p>
                        </div>
                    </div>
                </div>

                {/* Footer de contacto */}
                <div className="bg-gradient-to-r from-indigo-600 to-blue-600 rounded-2xl shadow-xl p-8 text-white">
                    <h3 className="text-xl font-bold mb-3 flex items-center gap-2">
                        <Mail className="w-6 h-6" />
                        ¿Necesita ayuda?
                    </h3>
                    <p className="mb-4 text-indigo-100">
                        Si tiene preguntas sobre la eliminación de datos o necesita asistencia, contáctenos:
                    </p>
                    <div className="space-y-2 text-sm">
                        <p><strong>Email:</strong> contacto@neotec.pe</p>
                        <p><strong>Página:</strong> https://wwww.neotec.pe</p>
                    </div>
                    <div className="mt-6 pt-6 border-t border-indigo-400">
                        <p className="text-sm text-indigo-100">
                            Para más información sobre cómo manejamos sus datos, consulte nuestra{' '}
                            <a href="/privacy" className="underline font-semibold hover:text-white">
                                Política de Privacidad
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};